<template>
    <v-snackbar v-model="show" v-bind:color="color" top>
        {{ message }}
        <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" v-on:click="show = false">Close</v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            message: '',
            color: ''
        };
    },
    created() {
        this.unsubscribeSnackbar = this.$store.subscribeAction({
            // Use 'after' so mutations are finished
            after: (action, store) => {
                if (action.type == 'snackbar/show') {
                    this.message = store.snackbar.message;
                    this.color = store.snackbar.color;
                    this.show = true;
                }
            }
        });
    },
    beforeDestroy() {
        this.unsubscribeSnackbar();
    }
};
</script>
